import "regenerator-runtime/runtime";

var _marked = /*#__PURE__*/regeneratorRuntime.mark(_callee);

/*
 Copyright (c) 2018 Wells Fargo. 45 Fremont St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Jeremy Levy

 Description:
 */
import { take, put, call, select } from 'redux-saga/effects';
import network from '../../../network/network';
import { workingStart, workingEnd } from '../../working/actions';
import * as actions from '../actions';
import { adapter } from '../data-adapter';
import { getFetchingWFCmsIds } from '../../selectors';
export default function _callee() {
  var _yield$take, cmsIds, url, onError, fetchingIds, data;

  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!true) {
            _context.next = 46;
            break;
          }

          _context.next = 3;
          return take(actions.WF_CMS_REQUEST_START);

        case 3:
          _yield$take = _context.sent;
          cmsIds = _yield$take.cmsIds;
          url = _yield$take.url;
          onError = _yield$take.onError;
          _context.prev = 7;

          if (!(window.mwfGlobals.cmsEntries && cmsIds)) {
            _context.next = 17;
            break;
          }

          _context.next = 11;
          return put(actions.wfCmsSetData({
            cmsIds: cmsIds,
            data: adapter(window.mwfGlobals.cmsEntries)
          }));

        case 11:
          _context.next = 13;
          return put(actions.wfCmsRequestEnd({
            cmsIds: cmsIds,
            fetching: false
          }));

        case 13:
          _context.next = 15;
          return put(workingEnd());

        case 15:
          _context.next = 37;
          break;

        case 17:
          _context.next = 19;
          return put(workingStart());

        case 19:
          if (!(cmsIds && url)) {
            _context.next = 37;
            break;
          }

          _context.next = 22;
          return select(getFetchingWFCmsIds, cmsIds);

        case 22:
          fetchingIds = _context.sent;

          if (fetchingIds.length) {
            _context.next = 28;
            break;
          }

          _context.next = 26;
          return put(workingEnd());

        case 26:
          _context.next = 37;
          break;

        case 28:
          _context.next = 30;
          return call(network().post, {
            postData: true,
            url: url,
            data: {
              'contentID': fetchingIds
            }
          });

        case 30:
          data = _context.sent;
          _context.next = 33;
          return put(actions.wfCmsSetData({
            cmsIds: fetchingIds,
            data: adapter(data)
          }));

        case 33:
          _context.next = 35;
          return put(actions.wfCmsRequestEnd({
            cmsIds: fetchingIds,
            fetching: false
          }));

        case 35:
          _context.next = 37;
          return put(workingEnd());

        case 37:
          _context.next = 44;
          break;

        case 39:
          _context.prev = 39;
          _context.t0 = _context["catch"](7);
          _context.next = 43;
          return put(workingEnd());

        case 43:
          onError && onError(new Error('Error fetching/loading CMS data'));

        case 44:
          _context.next = 0;
          break;

        case 46:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[7, 39]]);
}